import { useState } from "react";
import { regularizarSituacaoCTU } from "../../../uteis/cotaUsuario/Globais";
// --------------------- Import Services ---------------------
import { atualizarAssinaturaService } from "../services/atualizarAssinaturaService";
import { anunciopPropriedadeService } from "../services/anuncioPropriedadeService";
import { buscarAnuncioPropriedadeService } from "../services/BuscarAnuncioPropriedadeService";

export const useAtualizarAssinaturas = (
  assinaturaId: number,
  tipo: string,
  cotaUsuarioId: number | null
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const resetError = () => setError(null);

  const atualizarAssinatura = async () => {
    setIsLoading(true);
    try {
      switch (tipo) {
        case "ATIVA":
          if (cotaUsuarioId !== null && cotaUsuarioId !== undefined) {
            const data = await atualizarAssinaturaService(assinaturaId, tipo);
            if (data) {
              regularizarSituacaoCTU(cotaUsuarioId, "");
              const sucesso = await anunciopPropriedadeService(cotaUsuarioId);
              sucesso
                ? setSuccess("Assinatura ativada com sucesso!")
                : setError("Não foi possível anunciar propriedade.");
            } else {
              setError("Não foi possível ativar a assinatura.");
            }
          } else {
            setError(
              "Não é possível ativar a assinatura pois ela ainda não tem cota vinculada."
            );
          }
          break;

        case "DESATIVAR":
          const buscarAnuncio = cotaUsuarioId
            ? await buscarAnuncioPropriedadeService(cotaUsuarioId)
            : false;

          if (buscarAnuncio) {
            setError(
              "Não foi possível excluir a assinatura, pois já existe um anúncio vinculado."
            );
          } else {
            const data = await atualizarAssinaturaService(assinaturaId, tipo);
            if (data) {
              setSuccess("Assinatura excluída com sucesso!");
            } else {
              setError("Não foi possível excluir a assinatura!");
            }
          }
          break;
      }
    } catch (err: any) {
      setError(`Ocorreu um erro: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return { success, isLoading, error, atualizarAssinatura, resetError };
};
